import { gql } from "@apollo/client"
import { SplitModal, Text } from "@pallet-hq/hegel"
import { UpsellInfoModal_applylist } from "__generated__/UpsellInfoModal_applylist"

const UpsellInfoModalFragment = gql`
    fragment UpsellInfoModal_applylist on ApplylistType {
        id
        curatorName
        group {
            id
            upsellDetails
            upsellCurationStrategy
        }
    }
`

type UpsellInfoModalProps = {
    isOpen: boolean
    hideModal: () => void
    applylist: UpsellInfoModal_applylist
}

const UpsellInfoModal = ({ applylist, ...props }: UpsellInfoModalProps) => (
    <SplitModal
        width="540px"
        title={`How ${applylist.curatorName} curates talent`}
        info={applylist.group!.upsellDetails}
        style={{
            content: {
                minHeight: "432px",
            },
        }}
        {...props}
    >
        <Text variant="paragraphLarge">
            {applylist.group!.upsellCurationStrategy}
        </Text>
    </SplitModal>
)

UpsellInfoModal.fragment = UpsellInfoModalFragment
export default UpsellInfoModal
